import { getIntegrationDataLabel } from '@modules/integrationsV2/utils';
import { IntegrationChannelType } from 'generated/graphql';

export const getWarningTextForIncompleteIntegration = (
  channelType: IntegrationChannelType,
) => {
  const integrationDataLabel = getIntegrationDataLabel(channelType);

  if (!integrationDataLabel) {
    return '';
  }

  const isFileUploadIntegration =
    channelType === IntegrationChannelType.FileUpload;

  if (isFileUploadIntegration) {
    return `No ${integrationDataLabel} uploaded yet. Please upload the ${integrationDataLabel} you'd want to pull customer feedback from.`;
  }

  return `No ${integrationDataLabel} added yet. Please add the ${integrationDataLabel} you'd want to pull customer feedback from.`;
};
